// extracted by mini-css-extract-plugin
export default {"tags":"tags---V8g3D","tagsIcon":"tagsIcon---NqGy8"};